export default function scrollToBottom(el) {
    if (!el) return;

    el.scrollTo(0, el.scrollHeight)
}
